import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { GridModule, ExcelModule } from '@progress/kendo-angular-grid';
import { AppTemplateDirective } from '../templateservice/apptemplate.directive';
import { HttpHelperModule } from 'nglhelper';
import { NumericTextBoxModule, SwitchModule } from '@progress/kendo-angular-inputs';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { PickListModule } from 'primeng/picklist'
import { DefaultSrcDirective } from '../directives/defaultSrc.directive';

@NgModule({
    imports: [HttpHelperModule, GridModule, ExcelModule, MatCheckboxModule, MatMenuModule, MatTooltipModule, MatSnackBarModule, MatRadioModule, MatTabsModule, MatCardModule, MatListModule,
         DateInputsModule, SwitchModule, NumericTextBoxModule, PickListModule],
    declarations: [AppTemplateDirective,DefaultSrcDirective],
    exports: [HttpHelperModule, GridModule, ExcelModule, MatCheckboxModule, MatMenuModule, MatTooltipModule, MatSnackBarModule, MatRadioModule, MatTabsModule, MatCardModule, MatListModule,
         DateInputsModule, SwitchModule, NumericTextBoxModule, PickListModule, DefaultSrcDirective, AppTemplateDirective]
})
export class AppFormModule { }

